import React from 'react';

const Loading = () => (
  <div className='loading'>
    <div className='loading__spinner' />
  </div>
)

export default Loading;
